<template>
  <div class="gdpr-settings">
    <CookieSettingsOption
      :title="SETTING_TEXT.NECESSARY.title"
      :description="SETTING_TEXT.NECESSARY.description"
      :model-value="true"
      :disabled="true"
    />
    <CookieSettingsOption
      v-if="usesStatistics"
      v-model="statisticsConsent"
      :title="SETTING_TEXT.STATISTICS.title"
      :description="SETTING_TEXT.STATISTICS.description"
    />
    <CookieSettingsOption
      v-if="usesMarketing"
      v-model="marketingConsent"
      :title="SETTING_TEXT.MARKETING.title"
      :description="SETTING_TEXT.MARKETING.description"
    />
    <div class="gdpr-settings__actions">
      <q-btn
        label="I Accept"
        unelevated
        no-caps
        class="gdpr-btn gdpr-btn--accept"
        @click="onAccept"
      />
      <q-btn
        :label="t('common.back')"
        unelevated
        no-caps
        outline
        class="gdpr-btn gdpr-btn--outline"
        @click="emit('back')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SETTING_TEXT } from 'src/services/gdpr'
import CookieSettingsOption from './CookieSettingsOption.vue'
import type { ConsentCookieContent } from 'src/services/gdpr'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  usesStatistics?: boolean
  usesMarketing?: boolean
}>()

const emit = defineEmits<{
  (e: 'accept', consent: ConsentCookieContent): void
  (e: 'back'): void
}>()

const statisticsConsent = ref(props.usesStatistics ?? false)
const marketingConsent = ref(props.usesMarketing ?? false)

const onAccept = () => {
  emit('accept', {
    consent: true,
    statistics: props.usesStatistics ? statisticsConsent.value : false,
    marketing: props.usesMarketing ? marketingConsent.value : false
  })
}
</script>

<style scoped>
.gdpr-settings__actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
}
</style>
